export var HelpMenuTestIds;
(function (HelpMenuTestIds) {
    HelpMenuTestIds["Button"] = "help-menu-button";
    HelpMenuTestIds["Popover"] = "help-menu-popover";
    HelpMenuTestIds["Documentation"] = "help-menu-documentation";
    HelpMenuTestIds["WhatsNew"] = "help-menu-whats-new";
})(HelpMenuTestIds || (HelpMenuTestIds = {}));
export var DeprecatedHelpItems;
(function (DeprecatedHelpItems) {
    DeprecatedHelpItems["BLINK_KEYWORDS"] = "BLINK_KEYWORDS";
    DeprecatedHelpItems["BLINK_RELEASE_NOTES"] = "BLINK_RELEASE_NOTES";
    DeprecatedHelpItems["BLINK_DOCUMENTATION"] = "BLINK_DOCUMENTATION";
    DeprecatedHelpItems["BLINK_DOWNLOADS"] = "BLINK_DOWNLOADS";
})(DeprecatedHelpItems || (DeprecatedHelpItems = {}));
export const DeprecatedHelpItemIds = Object.values(DeprecatedHelpItems);
export var SupportConfigItemIds;
(function (SupportConfigItemIds) {
    SupportConfigItemIds["HELP"] = "HELP";
    SupportConfigItemIds["GETTING_STARTED"] = "GETTING_STARTED";
    SupportConfigItemIds["WHATS_NEW"] = "WHATS_NEW";
    SupportConfigItemIds["CONTACT_SUPPORT"] = "CONTACT_SUPPORT";
    SupportConfigItemIds["ABOUT_INSTANCE"] = "ABOUT_INSTANCE";
})(SupportConfigItemIds || (SupportConfigItemIds = {}));
export var HelpMenuState;
(function (HelpMenuState) {
    HelpMenuState["OPEN"] = "OPEN";
    HelpMenuState["CLOSED"] = "CLOSED";
    HelpMenuState["DOCUMENTATION"] = "DOCUMENTATION";
    HelpMenuState["WHATS_NEW"] = "WHATS_NEW";
    HelpMenuState["GETTING_STARTED"] = "GETTING_STARTED";
    HelpMenuState["ABOUT_INSTANCE"] = "ABOUT_INSTANCE";
})(HelpMenuState || (HelpMenuState = {}));
//# sourceMappingURL=help-menu.const.js.map